import * as React from 'react';
import { Form } from 'formik';
import { dialogFormStyles } from './dialogFormCssDefs';

/**
 * @deprecated Deprecated — no pantry replacement available yet.
 * Migration: No direct pantry mapping — please reach out to the Design Systems team on Slack (e.g., #pantry-design-system) for assistance with a pantry replacement.
 */
export const DialogForm: React.FunctionComponent<React.PropsWithChildren<{}>> = ({ children }) => {
  return <Form css={dialogFormStyles}>{children}</Form>;
};
